import React from 'react';

function WindowSwitchComponent() {
    return <div>WindowSwitchComponent</div>;
}

export default WindowSwitchComponent;
